import { Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import Header from './Header';
import Footer from './Footer';

// Session Notification component
const SessionNotification = () => {
  const { tokenRefreshInProgress } = useAuth();
  
  if (!tokenRefreshInProgress) return null;
  
  return (
    <div className="fixed top-0 left-0 right-0 bg-yellow-400 text-center py-1 z-50 text-sm font-medium">
      Reconnecting to server... Please wait.
    </div>
  );
};

function Layout() {
  const location = useLocation();
  const isHomePage = location.pathname === '/';

  const baseMainClasses = 'flex-grow pt-8 pb-40';
  const containerClasses = 'container mx-auto px-4';

  const mainClassName = isHomePage 
    ? baseMainClasses 
    : `${baseMainClasses} ${containerClasses}`;

  return (
    <div className="flex flex-col min-h-screen">
      <SessionNotification />
      <Header />
      <main className={mainClassName}>
        <Outlet />
      </main>
      <Footer />
    </div>
  );
}

export default Layout; 